import { selfAxios } from "../../../../../axios/selfAxios.js";
const reqSelectOrgMarketManageRightByFictitiousShopId = async (params) => {
  const {
    data: { data }
  } = await selfAxios.get("/ucenterapi/internal/org/selectOrgMarketManageRightByFictitiousShopId", { params, _cache: true });
  return data;
};
export { reqSelectOrgMarketManageRightByFictitiousShopId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/internal/org/selectOrgMarketManageRightByFictitiousShopId/get.js